// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   DEALER MIX VOLUME COMPONENT STYLES
   ============================================ */

.vehicle-mix {
	width: 50%;
	height: 100%;
	border: 1px solid #e9ecef;
	border-collapse: collapse;
	border-spacing: 2px;
	margin: 1rem 0;
}

.vehicle-mix th {
	border: 1px solid #e9ecef;
	background: #f8f9fa;
	color: #343a40;
	font-weight: 600;
	padding: 0.5rem;
}

.vehicle-mix td {
	border: 1px solid #e9ecef;
	padding: 0.5rem;
	color: #495057;
}

.submit-button {
	float: right;
}

.lbltbl td {
	text-align: center;
}

/* ============================================
   PRIMENG BUTTON OVERRIDES
   ============================================ */
:host ::ng-deep .p-button {
	background: #27405f !important;
	border-color: #27405f !important;
	font-weight: 600 !important;
}

:host ::ng-deep .p-button:enabled:hover {
	background: #1d3049 !important;
	border-color: #1d3049 !important;
}

:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
	background: #27405f !important;
	color: #ffffff !important;
}

/* PrimeNG 19 checkbox checked state */
:host ::ng-deep .p-checkbox-checked .p-checkbox-box {
	border-color: #27405f !important;
	background: #27405f !important;
}

:host ::ng-deep .p-checkbox-checked .p-checkbox-icon {
	color: #ffffff !important;
}

:host ::ng-deep .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
	border-color: #1d3049 !important;
	background: #1d3049 !important;
}
/* ============================================
   COPY BUTTON STYLES
   ============================================ */
.copy-button {
	padding: 0.25rem 0.5rem !important;
	font-family: "Trebuchet MS", Arial, Helvetica, sans-serif !important;
	font-weight: bold !important;
	background: #27405f !important;
	color: white !important;
	border: none !important;
	border-radius: 4px !important;
	cursor: pointer !important;
	margin-left: 0.5rem !important;
	font-size: 0.875rem !important;
}

.copy-button:hover {
	box-shadow: 2px 2px 0px #0F3771 !important;
	background: #2399e5 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dealer-mix-volume/dealer-mix-volume.component.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;CACC,UAAU;CACV,YAAY;CACZ,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;iDAEiD;AACjD;CACC,8BAA8B;CAC9B,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA,sCAAsC;AACtC;CACC,gCAAgC;CAChC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,8BAA8B;AAC/B;AACA;;iDAEiD;AACjD;CACC,kCAAkC;CAClC,oEAAoE;CACpE,4BAA4B;CAC5B,8BAA8B;CAC9B,uBAAuB;CACvB,uBAAuB;CACvB,6BAA6B;CAC7B,0BAA0B;CAC1B,8BAA8B;CAC9B,8BAA8B;AAC/B;;AAEA;CACC,0CAA0C;CAC1C,8BAA8B;AAC/B","sourcesContent":["/* ============================================\n   DEALER MIX VOLUME COMPONENT STYLES\n   ============================================ */\n\n.vehicle-mix {\n\twidth: 50%;\n\theight: 100%;\n\tborder: 1px solid #e9ecef;\n\tborder-collapse: collapse;\n\tborder-spacing: 2px;\n\tmargin: 1rem 0;\n}\n\n.vehicle-mix th {\n\tborder: 1px solid #e9ecef;\n\tbackground: #f8f9fa;\n\tcolor: #343a40;\n\tfont-weight: 600;\n\tpadding: 0.5rem;\n}\n\n.vehicle-mix td {\n\tborder: 1px solid #e9ecef;\n\tpadding: 0.5rem;\n\tcolor: #495057;\n}\n\n.submit-button {\n\tfloat: right;\n}\n\n.lbltbl td {\n\ttext-align: center;\n}\n\n/* ============================================\n   PRIMENG BUTTON OVERRIDES\n   ============================================ */\n:host ::ng-deep .p-button {\n\tbackground: #27405f !important;\n\tborder-color: #27405f !important;\n\tfont-weight: 600 !important;\n}\n\n:host ::ng-deep .p-button:enabled:hover {\n\tbackground: #1d3049 !important;\n\tborder-color: #1d3049 !important;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n\tbackground: #27405f !important;\n\tcolor: #ffffff !important;\n}\n\n/* PrimeNG 19 checkbox checked state */\n:host ::ng-deep .p-checkbox-checked .p-checkbox-box {\n\tborder-color: #27405f !important;\n\tbackground: #27405f !important;\n}\n\n:host ::ng-deep .p-checkbox-checked .p-checkbox-icon {\n\tcolor: #ffffff !important;\n}\n\n:host ::ng-deep .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {\n\tborder-color: #1d3049 !important;\n\tbackground: #1d3049 !important;\n}\n/* ============================================\n   COPY BUTTON STYLES\n   ============================================ */\n.copy-button {\n\tpadding: 0.25rem 0.5rem !important;\n\tfont-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif !important;\n\tfont-weight: bold !important;\n\tbackground: #27405f !important;\n\tcolor: white !important;\n\tborder: none !important;\n\tborder-radius: 4px !important;\n\tcursor: pointer !important;\n\tmargin-left: 0.5rem !important;\n\tfont-size: 0.875rem !important;\n}\n\n.copy-button:hover {\n\tbox-shadow: 2px 2px 0px #0F3771 !important;\n\tbackground: #2399e5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
